module.exports = __webpack_public_path__ + "static/media/quill.5f28d10e.png";